import { jsx, jsxs } from "react/jsx-runtime";
import { Stack, Columns, Column, Box } from "braid-design-system";
import { Wrapper, Banner, Title, Tagline, Inclusions, Price, CallToAction } from "../../layouts/GridLayout/GridLayout.mjs";
import { Image } from "../../elements/Image/Image.mjs";
import { leftColumn, cta, rightColumn } from "./RowPanel.css.mjs";
const LeftColumn = ({
  product,
  isSelected,
  isLoading,
  onSelect
}) => {
  var _a, _b, _c, _d;
  return /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsxs(Box, { className: leftColumn, children: [
    /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
      product.banner ? /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Banner, { type: product.banner.type, variant: "narrow" }) }) : null,
      product.title || product.tagline ? /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
        product.title ? /* @__PURE__ */ jsx(Title, { ...product.title }) : null,
        product.tagline ? /* @__PURE__ */ jsx(
          Tagline,
          {
            content: product.tagline.content,
            variant: product.tagline.variant
          }
        ) : null
      ] }) : null,
      ((_b = (_a = product.inclusions) == null ? void 0 : _a.content) == null ? void 0 : _b.length) ? /* @__PURE__ */ jsx(Inclusions, { inclusions: product.inclusions }) : null,
      product.price.type !== "HiddenPrice" ? /* @__PURE__ */ jsx(Price, { price: product.price, size: "medium" }) : null
    ] }),
    product.cta ? /* @__PURE__ */ jsx(Box, { marginTop: "medium", className: cta, children: /* @__PURE__ */ jsx(
      CallToAction,
      {
        id: product.id,
        isSelected,
        isLoading,
        onClick: (intent) => onSelect(product.id, product.type, intent),
        url: (_c = product.cta) == null ? void 0 : _c.url,
        variant: (_d = product.cta) == null ? void 0 : _d.variant
      }
    ) }) : null
  ] }) });
};
const RightColumn = ({ product }) => {
  if (!product.image) {
    return null;
  }
  return /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(Box, { className: rightColumn, children: product.image ? /* @__PURE__ */ jsx(Image, { image: product.image }) : null }) });
};
const RowPanel = ({
  product,
  isSelected,
  isLoading,
  onSelect
}) => /* @__PURE__ */ jsx(Wrapper, { product, children: /* @__PURE__ */ jsx(Stack, { space: "large", children: /* @__PURE__ */ jsxs(Columns, { space: "medium", collapseBelow: "tablet", reverse: true, children: [
  /* @__PURE__ */ jsx(RightColumn, { product }),
  /* @__PURE__ */ jsx(
    LeftColumn,
    {
      product,
      isSelected,
      isLoading,
      onSelect
    }
  )
] }) }) });
export {
  RowPanel
};
